import * as types from './types';

const getPropertyType = () => ({
  type: types.GET_PROPERTY_TYPE,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/realestatetypes`,
    method: 'GET'
  }
});

const getFormValues = postingId => {
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_OPERATION/${postingId}`,
      method: 'GET'
    }
  };
};

const getSubPropertyType = realEstateTypeId => ({
  type: types.GET_SUBPROPERTY_TYPE,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/realestatetypes/${realEstateTypeId}/subtypes`,
    method: 'GET'
  }
});

const updateFormValues = data => {
  return {
    type: types.RESET_INFO,
    payload: data
  };
};
const resetInfo = () => ({
  type: types.RESET_INFO
});

export { getPropertyType, getSubPropertyType, getFormValues, updateFormValues, resetInfo };
